// Esta función se utiliza para abrir un acordeon desde un anchor link
// Se utiliza ahora en fichas de arte de museos al hacer click en la siguiente copia en venta (next unit for sale)

function scrollToOpenAnchor() {
    const anchorLinks = document.querySelectorAll(".toOpenAnchor");

    if (!anchorLinks.length) return;

    anchorLinks.forEach((anchorLink) => {
        anchorLink.addEventListener("click", ()=> {
            const anchorID = anchorLink.getAttribute("href").replace("#", "");

            const accordeons = document.querySelectorAll(".accordion-item");
            accordeons.forEach((accordeon) => {
                
                const dataToggle = accordeon.querySelector("[data-toggle-accordion]")
                if(accordeon.id === anchorID) {
                    dataToggle.click();
                }
                
            })
        })
    })
}

scrollToOpenAnchor();